<script setup>
import { useI18n } from 'vue-i18n'
import { Input, Textarea } from '@drama/ui'
import { NOVEL_GENRE_LIMIT } from '@drama/contracts/novel'
import FormField from '../NovelFormField.vue'
import NovelImageField from '../NovelImageField.vue'
import NovelCoverLocalesField from '../NovelCoverLocalesField.vue'
import NovelTagPicker from '../NovelTagPicker.vue'
import { useSectionModel } from './section-model.js'
import './novel-sections.css'
const props = defineProps({ modelValue: { type: Object, required: true }, issues: { type: Array, default: () => [] }, upload: { type: Function, required: true }, cover_url: { type: String, default: '' }, load_tags: { type: Function, default: null }, disabled: { type: Boolean, default: false } })
const emit = defineEmits(['update:modelValue', 'blocked', 'clear-cover'])
const { t } = useI18n()
const { bind, invalid, error } = useSectionModel(props, emit)
</script>
<template>
  <section
    class="novel-entity"
    data-testid="novel-storefront-group"
  >
    <FormField
      :error="error(['title'])"
      required
      :label="t('novelStudio.fields.title')"
    >
      <Input
        v-bind="bind(['title'])"
        maxlength="120"
        data-testid="novel-overview-title"
      />
    </FormField>
    <FormField
      :label="t('novelAuthoring.synopsis')"
      :hint="t('novelAuthoring.synopsisHint')"
    >
      <Textarea
        v-bind="bind(['synopsis'])"
        :rows="4"
        maxlength="1200"
        data-testid="novel-synopsis"
      />
    </FormField>
    <FormField
      :error="error(['genres'])"
      :label="t('novelAuthoring.genres')"
      :hint="t('novelAuthoring.tagsHint', { max: NOVEL_GENRE_LIMIT })"
    >
      <NovelTagPicker
        v-bind="bind(['genres'], [])"
        :load_tags="load_tags"
        :disabled="disabled"
      />
    </FormField>
    <NovelImageField
      :model-value="cover_url"
      :label="t('novelStudio.assets.uploadCover')"
      tag="cover"
      :upload="upload"
      :alt="modelValue.title"
      :invalid="invalid(['cover_asset_id'])"
      data-path="cover_asset_id"
      @update:model-value="url => { if (!url) emit('clear-cover') }"
    />
    <NovelCoverLocalesField :title="modelValue.title" />
  </section>
</template>
